import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'text-color', 'TextColor', [["path",{"d":"M9 15v-7a3 3 0 0 1 6 0v7"}],["path",{"d":"M9 11h6"}],["path",{"d":"M5 19h14"}]]);